import type { Database } from 'node-sqlite3-wasm';
import type { SymbolImportBinding, SymbolTag } from '../../types.js';

export function insertSymbolTagsForContent(
  db: Database,
  contentHash: string,
  filePath: string,
  tags: readonly SymbolTag[],
): void {
  const ins = db.prepare(
    `INSERT OR IGNORE INTO symbol_index_tag
      (content_hash, file_path, name, role, kind, start_line, start_column, end_line, end_column,
       scope_start_line, scope_start_column, parent_scope_start_line, parent_scope_start_column,
       nav_target_path, scope_chain)
     VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)`,
  );
  try {
    for (const tag of tags) {
      ins.run([
        contentHash,
        filePath,
        tag.name,
        tag.role,
        tag.kind,
        tag.startLine,
        tag.startColumn,
        tag.endLine,
        tag.endColumn,
        tag.scopeStartLine ?? null,
        tag.scopeStartColumn ?? null,
        tag.parentScopeStartLine ?? null,
        tag.parentScopeStartColumn ?? null,
        tag.navTargetPath ?? null,
        tag.scopeChain ?? null,
      ]);
    }
  } finally {
    ins.finalize();
  }
}

export function insertSymbolImportsForContent(
  db: Database,
  contentHash: string,
  filePath: string,
  imports: readonly SymbolImportBinding[],
): void {
  const ins = db.prepare(
    `INSERT OR IGNORE INTO symbol_index_import
      (content_hash, file_path, local_name, source_name, module_specifier, source_file_path, import_kind, start_line, start_column)
     VALUES (?, ?, ?, ?, ?, ?, ?, ?, ?)`,
  );
  try {
    for (const binding of imports) {
      ins.run([
        contentHash,
        filePath,
        binding.localName,
        binding.sourceName,
        binding.moduleSpecifier,
        binding.sourceFilePath,
        binding.importKind,
        binding.startLine,
        binding.startColumn,
      ]);
    }
  } finally {
    ins.finalize();
  }
}
